module.exports = __webpack_public_path__ + "img/fenxiao@2x.2b94a344.png";